export default "__VITE_ASSET__ChhDdfdJ__"